import { routeMappings, SessionStore } from '../../constants';
import { getStore } from '../../store';
import { Template, TemplateType } from '../../store/interfaces';
import { isSimplifiedFlow, isSimplifiedFormSubmited } from '../../workflowConfigurablePages/utils/simplifiedFormStatus';
import { formRoutes } from './../../constants/routeMappings';

export const handleTCPlusRedirection = (url: string, template: Template): string => {
  const companySettings = getStore()?.state?.companySettings;
  const formStatusSession = sessionStorage.getItem(SessionStore.formStatus);
  const formStatus = formStatusSession && JSON.parse(formStatusSession);
  const basicTemplate = template.type === TemplateType.BASIC_EXPERIENCE_LITE;
  const fromAnyFormPage = formRoutes.some((formRoute) => window.location.href.includes(formRoute));

  if (companySettings && formStatus) {
    if (isSimplifiedFormSubmited()) return url;
    else if (isSimplifiedFlow()) return routeMappings['SIMPLIFIED_FORM'];
    else if (
      basicTemplate &&
      (window.location.href.includes(routeMappings['AUTH_LOGIN']) ||
        window.location.href.includes(routeMappings['SSO']) ||
        window.location.href.includes(routeMappings['AUTH_WELCOME']) ||
        window.location.href.includes(routeMappings['AUTH_RESET_PASSWORD']))
    )
      return url;
    else if (companySettings.showAppform && !formStatus.applicationFormSubmitted)
      return routeMappings['APPLICATION_FORM'];
    else if (companySettings.allowCEBDemographyResearch && !formStatus.researchQuestionSubmitted)
      return routeMappings['RESEARCH_QUESTIONS'];
    else if (companySettings.showEeo && !formStatus.eeoSubmitted) return routeMappings['EEO'];
    else if (companySettings.enableOfccp && !formStatus.ofccpSubmitted) return routeMappings['OFCCP'];
    else if (basicTemplate && fromAnyFormPage) return `${routeMappings['FORM_COMPLETION']}`;
  }
  return url;
};
